import { EColor } from '@core/type';

import { SelectCrossPage } from './SelectCrossPage';
import { SelectOption } from './SelectOption';
import { SelectBaseProps } from './interface-select';

export const SelectInline = ({ options, ...restProps }: SelectBaseProps) => {
  return (
    <SelectCrossPage
      textColor={EColor.PRIMARY}
      textHoverColor={{ semanticType: EColor.PRIMARY, variant: EColor.DARK }}
      iconColor={EColor.PRIMARY}
      Option={SelectOption}
      {...restProps}
      name={'selectLanguage'}
      options={options}
    />
  );
};
